(function ($) {
	$(function () {
		let slides	=	[];
		
		$('.mv .slide').find("img").each(function () {
			slides.push({
				src	:	$(this).attr("src"),
			});
		});

		$('.mv .slide').vegas({
			slides			:	slides,
			delay			:	'2500',
			duration		:	'4000',
			firstTransition	:	'fade',
			transition		:	'zoomOut',
		});

		const media 	=	window.matchMedia('screen and (min-width: 969px)');
		const $business	=	$(".business.slide").clone();
		let timer		=	"";

		$(media).on("change", function (e) {
			clearTimeout(timer);

			if(this.matches) {
				$(".business.slide").html($business.html());
			}
			else {
				$(".business.slide .item").each(function () {
					$(".business.slide .items").prepend($(this));
				});

				function fadeBusiness() {
					if(media.matches) {
						return;
					}

					$(".business.slide .item:last > dl > dt").stop().fadeIn(1000);
					$(".business.slide .item:last").stop().fadeIn(1000, function () {
						let $item	=	$(".business.slide .item:first").hide();

						$(".business.slide .items").append($item);

						setTimeout(function () {
							fadeBusiness();
						}, 2600);
					});
				}
					
				fadeBusiness();
			}
		}).trigger("change");
	});
})(jQuery);